import { DecimalPipe, PercentPipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { BiSpuioService } from "../bi-spuio.service";
import { ConversaoLibraConverte } from "./../../../../shared/conversao-libra/conversao-libra-converte";
import { Filtros } from "./../../../../shared/crud/Filtro/Filtros";
import { ListaBase } from "./../../../../shared/crud/ListaBase";
import { ExportExcelService } from "./../../../../shared/excel-service/export-excel.service";
import { FiltroDataComponent } from "./../../../../shared/filtro-data/filtro-data.component";
import { FormatarData } from "./../../../../shared/formatarData";
import { PrintPdfService } from "./../../../../shared/print-pdf/print-pdf.service";
import { Parametro } from "./../../../../shared/service-base/parametro";

@Component({
  selector: "app-bi-spuio-lista",
  templateUrl: "./bi-spuio-lista.component.html",
  styleUrls: ["./bi-spuio-lista.component.css"],
})
export class BiSpuioListaComponent extends ListaBase implements OnInit {
  codigo_dealer: any;
  nome_dealer: any;
  ano_anterior_motos = 0;
  ano_atual_motos = 0;
  percentual_motos = 0;
  ano_anterior_pecas = 0;
  ano_atual_pecas = 0;
  percentual_pecas = 0;
  ano_anterior_spuio = 0;
  ano_atual_spuio = 0;
  crescimento_spuio = 0;
  percentual_spuio = 0;
  venda_oportunidade = 0;
  cols: any[];
  colsTitle: any[];
  _selectedColumns: any[];
  _selectedColumnsTitle: any[];
  dataInicialFormata;
  Sysdate: FiltroDataComponent = new FiltroDataComponent();
  max: any;
  min: any;
  carregando = false;
  InicialData; // Set the first Day of month
  FinalData; // set the last day of query
  parametrosFiltro: any;
  tituloTabela: string;
  textoData: string;
  spuioDados: any;
  subscription;

  dadosTranslate = {
    Brasil: "businessIntelligence.SPUIO.brasil",
  };

  constructor(
    service: BiSpuioService,
    toastr: ToastrService,
    router: Router,
    private exportExcel: ExportExcelService,
    private printPdf: PrintPdfService,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private percent: PercentPipe,
    private number: DecimalPipe
  ) {
    super(service, toastr, router);
    const max = new Date();
    const min = new Date();

    this.max = {
      year: max.getFullYear(),
      month: max.getMonth() + 1,
      day: max.getUTCDate(),
    };
    this.min = {
      year: min.getFullYear() - 1,
      month: min.getMonth() + 1,
      day: min.getUTCDate() + 1,
    };
    this.route.queryParams.subscribe((params) => {
      this.parametrosFiltro = params;
      this.setaValorData(params["data_inicial"]);
      this.carregarFiltrosParametros();
    });
    this.nomeModulo = "bi-spuio";
  }

  ngOnInit(): void {
    this.buscar();
    
    //conversaolibra
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange.subscribe(
      (_event: LangChangeEvent) => {
        this.buscar();
      }
    );
    //fimConversaolibra
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setaValorData(dataInicial: Date) {
    const dt = new Date();
    if (dataInicial === undefined || dataInicial.toString() === "") {
      const dt = new Date();
      const dataInicial = {
        year: dt.getFullYear(),
        month: dt.getMonth() + 1,
        day: dt.getUTCDate(),
      };
      this.dataInicialFormata = new FormatarData(
        dataInicial.year,
        dataInicial.month,
        dataInicial.day,
        0,
        0,
        0
      ).getDataString();
      this.InicialData = dataInicial;
    } else {
      const now = new Date(dataInicial);
      this.InicialData = {
        year: now.getUTCFullYear(),
        month: now.getMonth() + 1,
        day: now.getUTCDate(),
      };
    }

    this.filtros = { data_inicial: this.InicialData };
  }

  get dataInicial(): any {
    return this.tratarGetDropDown(this.filtros.data_inicial);
  }
  set dataInicial(data) {
    this.filtros.data_inicial = this.getDataString(data);
  }

  tratarGetDropDown(selecionado: any): string {
    if (selecionado === null || selecionado === undefined) {
      return "";
    }
    return selecionado;
  }

  getDataString(data): any {
    return new FormatarData(
      data.year,
      data.month,
      data.day,
      0,
      0,
      0
    ).getDataString();
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {
          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.data_inicial;
  }

  carregar() {
    const objFiltro = new Filtros();

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        objFiltro.filtros.push(new Parametro(chave, this.filtros[chave]));
      }
    }
  }

  exportarExcel() {
    this.exportExcel.nomeModulo = this.nomeModulo;
    this.exportExcel.ExportTOExcel();
  }

  imprimePdf() {
    if (this.translate.currentLang == "br") {
      this.tituloTabela = "SPUIO - Ticket Médio de Peças";
      this.textoData = "Data Ref.:";
    } else if (this.translate.currentLang == "gb") {
      this.tituloTabela = "SPUIO - Average Parts Ticket";
      this.textoData = "Ref. Date:";
    }

    this.printPdf.nomeModulo = this.nomeModulo;
    this.printPdf.tituloTabela = this.tituloTabela;
    this.printPdf.textoData = this.textoData;
    this.printPdf.exportPDFA4(this.filtros.data_inicial);
  }

  getTranslate(value) {
    return this.dadosTranslate[value];
  }

  buscar() {
    this.ano_anterior_motos = 0;
    this.ano_atual_motos = 0;
    this.percentual_motos = 0;
    this.ano_anterior_pecas = 0;
    this.ano_atual_pecas = 0;
    this.percentual_pecas = 0;
    this.ano_anterior_spuio = 0;
    this.ano_atual_spuio = 0;
    this.crescimento_spuio = 0;
    this.percentual_spuio = 0;
    this.venda_oportunidade = 0;
    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }

    this.carregando = true;

    this.service.buscar(objFiltro).then((res) => {
      res.dados.forEach((dados) => {
        dados.ano_anterior_pecas = this.conversaoLibraConverte.conversaoLibra(dados.ano_anterior_pecas,);
        dados.ano_anterior_spuio = this.conversaoLibraConverte.conversaoLibra(dados.ano_anterior_spuio,);
        dados.ano_atual_pecas = this.conversaoLibraConverte.conversaoLibra(dados.ano_atual_pecas,);
        dados.ano_atual_spuio = this.conversaoLibraConverte.conversaoLibra(dados.ano_atual_spuio,);
        dados.crescimento_spuio = this.conversaoLibraConverte.conversaoLibra(dados.crescimento_spuio,);
        dados.venda_oportunidade = this.conversaoLibraConverte.conversaoLibra(dados.venda_oportunidade);
      });

      this.spuioDados = res.dados;
      this.calculandoTotal(res);
      this.orderBySpuio();

      this.carregando = false;
    });
  }

  private calculandoTotal(res) {
    this.nome_dealer = "Brasil";
    this.ano_atual_spuio = this.conversaoLibraConverte.conversaoLibra(res.total_ano_atual_spuio);
    this.venda_oportunidade = this.conversaoLibraConverte.conversaoLibra(res.totalVendaOportunidade);
    this.ano_atual_pecas = this.conversaoLibraConverte.conversaoLibra(res.totalAnoAtualPecas);
    this.ano_anterior_pecas = this.conversaoLibraConverte.conversaoLibra(res.totalAnoAnteriorPecas);
    this.crescimento_spuio = this.conversaoLibraConverte.conversaoLibra(res.totalCrescimentoSpuio);
    this.ano_anterior_spuio = this.conversaoLibraConverte.conversaoLibra(res.totalAnoAnteriorSpuio);
    this.ano_anterior_motos = (res.totalAnoAnteriorMotos).toFixed();
    this.ano_atual_motos = (res.totalAnoAtualMotos).toFixed();
    this.percentual_motos = (res.totalPercentualMotos);
    this.percentual_pecas = (res.totalPercentualPecas);
    this.percentual_spuio = (res.totalPercentualSpuio);
  }

  private orderBySpuio() {
    this.spuioDados.sort((a, b) => {
      let ano_atual_spuio_a = a.ano_atual_spuio;
      let ano_atual_spuio_b = b.ano_atual_spuio;

      if (ano_atual_spuio_a > ano_atual_spuio_b) return -1;
      if (ano_atual_spuio_a < ano_atual_spuio_b) return 1;

      return 0;
    });
  }

  getColor(index: any): string {
    let maior: string = "#9cc09c";
    let menor: string = "#c09c9c";

    if (index.ano_atual_spuio >= this.ano_atual_spuio) {
      return maior;
    } else {
      return menor;
    }
  }
}
